import { render, staticRenderFns } from "./TableInquiry.vue?vue&type=template&id=cc83336c&scoped=true"
import script from "./TableInquiry.vue?vue&type=script&lang=js"
export * from "./TableInquiry.vue?vue&type=script&lang=js"
import style0 from "./TableInquiry.vue?vue&type=style&index=0&id=cc83336c&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc83336c",
  null
  
)

export default component.exports